import { Reveal, MaskLines, SectionLabel } from "./Motion";
import { scrollToId } from "./SmoothScroll";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQ } from "@/lib/content";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-[#F3EFE8] py-28 sm:py-36">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal><SectionLabel index="05">Questions fréquentes</SectionLabel></Reveal>
          <h2 className="font-serif-d mt-8 text-4xl font-light leading-[1.08] text-[#1C2826] sm:text-5xl">
            <MaskLines lines={["Vos questions,", <>nos <em className="italic text-[#3D5A4C]">réponses</em>.</>]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-sm text-base leading-relaxed text-[#3E4A47]">
              Ces réponses sont générales. Chaque situation mérite une analyse personnalisée : n'hésitez pas à{" "}
              <button data-testid="faq-contact-link" onClick={() => scrollToId("contact")} className="text-[#3D5A4C] underline underline-offset-4">contacter le cabinet</button>.
            </p>
          </Reveal>
        </div>
      </div>
      <Reveal className="lg:col-span-7 lg:col-start-6">
        <Accordion type="single" collapsible className="border-t border-[#3D5A4C]/15">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-b border-[#3D5A4C]/15">
              <AccordionTrigger data-testid={`faq-question-${i}`}
                className="group gap-6 py-7 text-left hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#B39158]">
                <span className="flex items-baseline gap-5">
                  <span className="font-serif-d w-6 shrink-0 text-sm italic text-[#B39158]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-serif-d text-[1.45rem] font-normal leading-snug text-[#1C2826] transition-colors group-hover:text-[#3D5A4C] sm:text-2xl">{f.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="pb-8 pl-11 pr-4 text-[0.98rem] leading-relaxed text-[#3E4A47]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
